import React, { useState, useEffect } from 'react';
import { toast } from "react-toastify";
import DataService from "../services/tutorial.service";
import { useSelector, useDispatch } from "react-redux";
import { logUser } from "../actions/index";
function OtpVerification({ otpTo, phoneNumber, onVerificationSuccess, onBack }) {
    const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const [timer, setTimer] = useState(60);
    const [isResendDisabled, setIsResendDisabled] = useState(true);

    const dispatch = useDispatch();


    useEffect(() => {
        let interval = null;
        console.log('timer')
        console.log(timer)
        if (timer > 0 && isResendDisabled) {
            interval = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1);

            }, 1000);
        } else {
            setIsResendDisabled(false);
        }
        return () => clearInterval(interval);
    }, [timer]);

    const handleChange = (element, index) => {
        if (isNaN(element.value)) return false;

        setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);

        if (element.value && element.nextSibling) {
            element.nextSibling.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace') {
            setOtp([...otp.map((d, idx) => (idx === index ? '' : d))]);
            
            if (e.target.previousSibling) {
                e.target.previousSibling.focus();
            }
        }
    };

    const handleResendOTP = async () => {
        // Add your resend OTP logic here
        console.log('handleResendOTP')
        try {

            const HEADER = {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Cache-Control": "no-cache",
                    "Postman-Token": "42e6c291-9a09-c29f-f28f-11872e2490a5",
                },
            };
            // Add your OTP verification API call here
            const formData = new FormData();
            //   formData.append('otp', otpValue);
            formData.append('mobno', phoneNumber);
            const response = await DataService.reqotp(formData, HEADER);
            console.log('otp resend response')
            console.log(response)
            if (response.data.success) {
                setIsResendDisabled(true);
                setTimer(60);
                toast.info("OTP resent successfully!", {
                    theme: "colored",
                    position: "bottom-center",
                });
            }

            // Temporary success simulation - replace with actual API call
        } catch (error) {
            toast.error("Invalid OTP. Please try again.", {
                theme: "colored",
                position: "bottom-center",
            });
        }

    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const otpValue = otp.join('');

        if (otpValue.length !== 6) {
            toast.error("Please enter complete OTP", {
                theme: "colored",
                position: "bottom-center",
            });
            return;
        }

        try {
            const HEADER = {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "Cache-Control": "no-cache",
                    "Postman-Token": "42e6c291-9a09-c29f-f28f-11872e2490a5",
                },
            };
            // Add your OTP verification API call here
            const formData = new FormData();
            formData.append('otp', otpValue);
            formData.append('mobno', phoneNumber);
            const response = await DataService.otpverify(formData, HEADER);
            console.log('otp verify response')
            console.log(response)

            if (response.data.success) {
                var emptyArray = JSON.stringify(new Array(response.data.data));
                // console.log(emptyArray)
                localStorage.setItem("user", emptyArray);
                dispatch(logUser(response.data.data));
                onVerificationSuccess();
            }
            else if (response.data.success == false) {
                toast.error(response.data.msg, { theme: "colored", position: "bottom-center" });
            }

            // Temporary success simulation - replace with actual API call

        } catch (error) {
            toast.error("Invalid OTP. Please try again.", {
                theme: "colored",
                position: "bottom-center",
            });
        }
    };

    return (
        <div className="otp-verification-container">
            <h4>OTP Verification</h4>
            <p className="phone-text">
                Enter the OTP sent to {otpTo}
            </p>


            <form onSubmit={handleSubmit}>
                <div className="otp-input-container">
                    {otp.map((data, index) => (
                        <input
                            key={index}
                            type="text"
                            maxLength="1"
                            value={data}
                            onChange={(e) => handleChange(e.target, index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            onFocus={(e) => e.target.select()}
                        />
                    ))}
                </div>

                <div className="timer-container">
                    <p>
                        {timer > 0
                            ? `Resend OTP in ${timer}s`
                            : <span className="resend-link" onClick={isResendDisabled ? null : handleResendOTP}>
                                Resend OTP
                            </span>
                        }
                    </p>
                </div>

                <div className="button-container">
                    <button type="button" className="back-button" onClick={onBack}>
                        Back
                    </button>
                    <button type="submit" className="verify-button">
                        Verify OTP
                    </button>
                </div>
            </form>
        </div>
    );
}

export default OtpVerification; 